import FinishDocumentModalContainer from "./FinishDocumentModalContainer";

export default FinishDocumentModalContainer;
